define('templates',['handlebars'], function(Handlebars) {

this["Handlebars"] = this["Handlebars"] || {};
this["Handlebars"]["App"] = this["Handlebars"]["App"] || {};

this["Handlebars"]["App"]["adhoc.team.finder.results"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "aria-selected=\"true\"";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "        <div>"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.attributes : depth0)) != null ? stack1.name : stack1), depth0))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"content\" role=\"option\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <div class=\"ui grid\">\n    <div class=\"nine wide column\">\n      <div class=\"fullName\">"
    + this.escapeExpression(((helper = (helper = helpers.fullName || (depth0 != null ? depth0.fullName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"fullName","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n    <div class=\"seven wide column\">\n"
    + ((stack1 = helpers.each.call(depth0,((stack1 = (depth0 != null ? depth0.unitPersonList : depth0)) != null ? stack1.models : stack1),{"name":"each","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n</div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["base.finder"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"visualSearchView\" />\n<ui name=\"searchTableView\" />\n\n<ui name=\"selectedTableHeaderView\" />\n<ui name=\"selectedTableView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["selected.table.cell"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <ui name=\"columnChildView\" />\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.model : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hasChildView : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.provisioned : stack1),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"6":function(depth0,helpers,partials,data) {
    return "        <sup style=\"font-size: 1em;\"><i class=\"icon clock outline\" style=\"opacity: 0.9\"></i></sup>\n";
},"8":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useInlineLink : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.program(11, data, 0),"data":data})) != null ? stack1 : "");
},"9":function(depth0,helpers,partials,data) {
    return "    </a>\n";
},"11":function(depth0,helpers,partials,data) {
    return "    </span>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.useInlineLink : depth0),{"name":"unless","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <a\n      href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n      "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.linkAriaLabel : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      role=\"button\"\n      target=\""
    + alias3(((helper = (helper = helpers.linkTarget || (depth0 != null ? depth0.linkTarget : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"linkTarget","hash":{},"data":data}) : helper)))
    + "\"\n      tabindex=\""
    + alias3(((helper = (helper = helpers.linkTabIndex || (depth0 != null ? depth0.linkTabIndex : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"linkTabIndex","hash":{},"data":data}) : helper)))
    + "\"\n      style=\"position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px\"\n      ></a>\n";
},"15":function(depth0,helpers,partials,data) {
    var helper;

  return "aria-label=\""
    + this.escapeExpression(((helper = (helper = helpers.linkAriaLabel || (depth0 != null ? depth0.linkAriaLabel : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"linkAriaLabel","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.hasChildView : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["significant.financial.interest.object.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<h5 class=\"ui header\">Manage Questions</h5>\n<ui name=\"collectionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["significant.financial.interest.object.preview"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"tableView\" />\n<div class=\"right aligned column\">\n    <ui name=\"addRowButtonView\" />\n</div>";
},"useData":true});

this["Handlebars"]["App"]["significant.financial.interest.object.question.cell"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"labelView\" /> <ui name=\"titleView\" /> <ui name=\"requiredQuestionView\" />\n<div><ui type=\"text\" name=\"descriptionView\" /></div>\n<ui name=\"columnChildView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["significant.financial.interest.object.settings.sidebar.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"headerView\" />\n<ui name=\"headerDividerView\" />\n<div class=\"ui basic fitted segment\">\n  <div class=\"ui right floated basic fitted segment\">Preview</div>\n</div>\n<div class=\"ui basic fitted segment\">\n   <h5><ui name=\"previewLabelView\" /> <ui name=\"previewTitleView\" /> <ui name=\"previewTitleRequiredQuestionView\" /></h5>\n</div>\n <div class=\"ui basic fitted segment\">\n    <ui name=\"previewDescriptionView\" />\n</div>\n<div class=\"ui basic segment\">\n  <ui name=\"previewView\"/>\n</div>\n<ui name=\"designDividerView\" />\n<div class=\"ui basic fitted segment\">\n  <div class=\"ui right floated basic fitted segment\">Design</div>\n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"descriptionView\" />\n</div>\n\n<div class=\"ui basic fitted segment\">\n  <ui name=\"designView\" />  \n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"requiredQuestionView\" />\n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"doneButtonView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["local.checkbox"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "radio";
},"3":function(depth0,helpers,partials,data) {
    return "checkbox";
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "id=\""
    + this.escapeExpression(((helper = (helper = helpers.checkboxId || (depth0 != null ? depth0.checkboxId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"checkboxId","hash":{},"data":data}) : helper)))
    + "\"";
},"7":function(depth0,helpers,partials,data) {
    return "checked=\"checked\" aria-checked=\"true\"";
},"9":function(depth0,helpers,partials,data) {
    return "aria-checked=\"false\"";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "    <label "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.checkboxId : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n";
},"12":function(depth0,helpers,partials,data) {
    var helper;

  return "for=\""
    + this.escapeExpression(((helper = (helper = helpers.checkboxId || (depth0 != null ? depth0.checkboxId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"checkboxId","hash":{},"data":data}) : helper)))
    + "\"";
},"14":function(depth0,helpers,partials,data) {
    return "    </label>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function";

  return "<input\n        type=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.radio : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        role=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.radio : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n        "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.checkboxId : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n        name=\""
    + this.escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\"\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.value : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "")
    + "\n        tabindex=\"0\"\n>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useLabel : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useLabel : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["reporting.page"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<div>\n    <iframe src="
    + this.escapeExpression(((helper = (helper = helpers.reportUrl || (depth0 != null ? depth0.reportUrl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"reportUrl","hash":{},"data":data}) : helper)))
    + " style=\"height:70vh;width:95vw\" id=\"dare-ui\"></iframe>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["disclosure.review.setting"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<h2 class=\"resolution-setting-header\">"
    + alias3(((helper = (helper = helpers.headingText || (depth0 != null ? depth0.headingText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"headingText","hash":{},"data":data}) : helper)))
    + "</h2>\n<div class=\"resolution-setting-panel\">\n  <p>\n    "
    + alias3(((helper = (helper = helpers.settingDescription || (depth0 != null ? depth0.settingDescription : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"settingDescription","hash":{},"data":data}) : helper)))
    + "\n  </p>\n  <fieldset>\n    <legend>"
    + alias3(((helper = (helper = helpers.settingLabel || (depth0 != null ? depth0.settingLabel : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"settingLabel","hash":{},"data":data}) : helper)))
    + "</legend>\n    <ui type=\"checkbox\" name=\"choiceAdminOnly\" />\n    <ui type=\"checkbox\" name=\"choiceAdminorReviewers\" />\n  </fieldset>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["app.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div id=\"app-a11y-announcements\"></div>\n<div style=\"height: 100%; width: 100%; position: relative;\" class=\"pusher\">\n  <div id=\"app-header\"></div>\n  <div id=\"app-tasklist\"></div>\n  <div id=\"app-content-container\">\n    <div id=\"app-notifications\"></div>\n    <div id=\"app-content\" role=\"main\" aria-label=\"main content\"></div>\n    <div id=\"app-overlay\"></div>\n    <div id=\"app-dimmer-container\"></div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["image"] = Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams) {
    var stack1;

  return "<img\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.attributes : depth0),{"name":"each","hash":{},"fn":this.program(2, data, 2, blockParams),"inverse":this.noop,"data":data,"blockParams":blockParams})) != null ? stack1 : "")
    + ">\n";
},"2":function(depth0,helpers,partials,data,blockParams) {
    var alias1=this.lambda, alias2=this.escapeExpression;

  return "  "
    + alias2(alias1(blockParams[0][1], depth0))
    + "=\""
    + alias2(alias1(blockParams[0][0], depth0))
    + "\"\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.svgData : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.svgData || (depth0 != null ? depth0.svgData : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"svgData","hash":{},"data":data}) : helper)))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.attributes : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0, blockParams),"inverse":this.program(4, data, 0, blockParams),"data":data,"blockParams":blockParams})) != null ? stack1 : "");
},"useData":true,"useBlockParams":true});

this["Handlebars"]["App"]["label.component.view"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "for=\""
    + this.escapeExpression(((helper = (helper = helpers.forElementId || (depth0 != null ? depth0.forElementId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"forElementId","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<label "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.forElementId : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <ui name=\"labelView\" />\n</label>\n<ui name=\"contentView\" />\n<ui name=\"errorView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["three.column.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"three wide column\">\n    <ui name=\"leftColumnView\" />\n  </div>\n  <div class=\"ten wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n  <div class=\"three wide column\">\n    <ui name=\"rightColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["two.column.left.rail.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"three wide column\">\n    <ui name=\"railColumnView\" />\n  </div>\n  <div class=\"thirteen wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["two.column.right.rail.layout"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"pageHeaderView\" />\n<div class=\"ui grid\">\n  <div class=\"thirteen wide column\">\n    <ui name=\"contentColumnView\" />\n  </div>\n  <div class=\"three wide column\">\n    <ui name=\"railColumnView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["header.container"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"appHeaderView\"/>\n<ui name=\"headerNavView\"/>\n";
},"useData":true});

this["Handlebars"]["App"]["page.header"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui grid\">\n  <div class=\"sixteen wide tablet eight wide computer column\">\n    <div>\n      <ui name=\"headerView\" />\n    </div>\n    <ui name=\"breadcrumbView\" />\n  </div>\n  <div class=\"sixteen wide tablet eight wide computer right desktop aligned column\">\n    <ui name=\"actionsView\" /><ui name=\"actionsFromCollectionView\" />\n  </div>\n</div>\n\n<ui name=\"errorMessageView\" />\n\n<ui name=\"notificationView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["pagination"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui pagination grid stackable\">\n  <div class=\"seven wide column\">\n    <ui name=\"paginationDropdownView\" />\n  </div>\n  <div class=\"center aligned two wide column desktop only\">\n    <ui name=\"paginationCountView\" />\n  </div>\n  <div class=\"right aligned seven wide column desktop only\">\n    <ui name=\"paginationMenuView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["simple.pagination"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui pagination grid stackable\">\n  <div class=\"six wide column\">\n    <ui name=\"previousButtonView\" />\n  </div>\n  <div class=\"center aligned four wide column\">\n    <ui name=\"paginationCountView\" />\n  </div>\n  <div class=\"right aligned six wide column\">\n    <ui name=\"nextButtonView\" />\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["list.page"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"ui tertiary segment top attached\">\n  <ui name=\"tokenInputView\" />\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ui name=\"pageHeaderView\" />\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useVisualSearch : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<ui name=\"tableView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["accordion"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <div class=\"title\" data-index=\""
    + alias3(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"index","hash":{},"data":data}) : helper)))
    + "\">\n    <i class=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + " icon\"></i>\n    "
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n  </div>\n  <div class=\"content\"></div>\n";
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)));
},"4":function(depth0,helpers,partials,data) {
    return "dropdown";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.items : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["breadcrumb.divider"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.dividerIcon || (depth0 != null ? depth0.dividerIcon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"dividerIcon","hash":{},"data":data}) : helper)))
    + " icon divider\" aria-hidden=\"true\" role=\"none presentation\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"divider\" aria-hidden=\"true\" role=\"none presentation\"> "
    + this.escapeExpression(((helper = (helper = helpers.divider || (depth0 != null ? depth0.divider : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"divider","hash":{},"data":data}) : helper)))
    + " </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.dividerIcon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["breadcrumb"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "muted";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<span class=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.muted : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"useData":true});

this["Handlebars"]["App"]["button"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"4":function(depth0,helpers,partials,data) {
    var helper;

  return "  "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n";
},"6":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <div class=\"ui label button-badge circular "
    + alias3(((helper = (helper = helpers.badgeColor || (depth0 != null ? depth0.badgeColor : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"badgeColor","hash":{},"data":data}) : helper)))
    + " small\">\n    <span class=\"text\">"
    + alias3(((helper = (helper = helpers.badgeText || (depth0 != null ? depth0.badgeText : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"badgeText","hash":{},"data":data}) : helper)))
    + "</span>\n  </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconRight : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.badge : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.iconRight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["calendar.appointment"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"time\">"
    + alias3(((helper = (helper = helpers.time || (depth0 != null ? depth0.time : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"time","hash":{},"data":data}) : helper)))
    + "</div>\n<div class=\"text\">"
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>";
},"useData":true});

this["Handlebars"]["App"]["calendar.cell"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "        <div class=\"appointment\"></div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"date","hash":{},"data":data}) : helper)))
    + "</div>\n<table>\n  <tr>\n    <td>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.appointment : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "      <div class=\"appointments\"></div>\n    </td>\n  </tr>\n</table>\n<ui name=\"label\"></ui>";
},"useData":true});

this["Handlebars"]["App"]["calendar.cell.more"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<i class=\"icon chevron down large\"></i>";
},"useData":true});

this["Handlebars"]["App"]["calendar.date.display.dropdown"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"month\"><ui name=\"monthView\"></ui></span> \n<span class=\"year\"><ui name=\"yearView\"></ui></span>";
},"useData":true});

this["Handlebars"]["App"]["calendar.date.display"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<span class=\"month\">"
    + alias3(((helper = (helper = helpers.month || (depth0 != null ? depth0.month : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"month","hash":{},"data":data}) : helper)))
    + "</span> \n<span class=\"year\">"
    + alias3(((helper = (helper = helpers.year || (depth0 != null ? depth0.year : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"year","hash":{},"data":data}) : helper)))
    + "</span>";
},"useData":true});

this["Handlebars"]["App"]["calendar.default.controls"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<table style=\"width: 100%; table-layout: fixed;\">\n  <tr>\n    <td style=\"width: 1px;\" class=\"left wrapper\">\n      <ui name=\"left\" />\n    </td>\n    <td>\n      <table>\n        <tr>\n          <td class=\"previous\">\n            <div class=\"control\">\n              <i class=\"chevron left icon\" tabindex=\"0\"></i>\n            </div>\n          </td>\n          <td class=\"title\">\n            <ui name=\"content\" />\n          </td>\n          <td class=\"next\">\n            <div class=\"control\">\n              <i class=\"chevron right icon\" tabindex=\"0\"></i>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </td>\n    <td style=\"width: 1px;\" class=\"right wrapper\">\n      <div style=\"float: right;\">\n        <ui name=\"right\" />\n      </div>\n    </td>\n  </tr>\n</table>";
},"useData":true});

this["Handlebars"]["App"]["calendar"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"controls\"></ui>\n<ui name=\"content\"></ui>\n";
},"useData":true});

this["Handlebars"]["App"]["calendar.week.appointment"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<table class=\"layout full height\">\n  <tbody>\n    <tr>\n      <td class=\"collapsing\">\n        <div class=\"time\">"
    + alias3(((helper = (helper = helpers.time || (depth0 != null ? depth0.time : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"time","hash":{},"data":data}) : helper)))
    + "</div>\n      </td>\n      <td>\n        <div class=\"text\">"
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n      </td>\n    </tr>\n  </tbody>\n</table>\n";
},"useData":true});

this["Handlebars"]["App"]["calendar.week.appointment.list"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"position layout list\"></div>";
},"useData":true});

this["Handlebars"]["App"]["calendar.week.day.cell"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)));
},"useData":true});

this["Handlebars"]["App"]["calendar.week"] = Handlebars.template({"1":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper;

  return "                    <tr class=\"minor interval\">\n                      <td class=\"time gutter\">\n                        &nbsp;\n                      </td>\n"
    + ((stack1 = helpers.each.call(depth0,(depths[1] != null ? depths[1].weekdays : depths[1]),{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                    </tr>\n                    <tr class=\"major interval\">\n                      <td class=\"time gutter\"><div class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div></td>\n"
    + ((stack1 = helpers.each.call(depth0,(depths[1] != null ? depths[1].weekdays : depths[1]),{"name":"each","hash":{},"fn":this.program(2, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                    </tr>\n";
},"2":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                        <td class=\"time interval "
    + ((stack1 = helpers["if"].call(depth0,(depths[1] != null ? depths[1].businessHour : depths[1]),{"name":"if","hash":{},"fn":this.program(3, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\"></td>\n";
},"3":function(depth0,helpers,partials,data) {
    return "business";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"wrapper\">\n  <table class=\"layout fixed full height\">\n    <thead>\n      <tr>\n        <td class=\"calendarheader\">\n          <div style=\"margin-right: "
    + alias3(((helper = (helper = helpers.scrollbarWidth || (depth0 != null ? depth0.scrollbarWidth : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"scrollbarWidth","hash":{},"data":data}) : helper)))
    + "px;\">\n            <ui name=\"controls\"></ui>\n          </div>\n          <div style=\"margin-right: "
    + alias3(((helper = (helper = helpers.scrollbarWidth || (depth0 != null ? depth0.scrollbarWidth : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"scrollbarWidth","hash":{},"data":data}) : helper)))
    + "px;\">\n          <table class=\"layout fixed\">\n            <thead>\n              <tr class=\"header\">\n                <th class=\"time gutter\"></th>\n              </tr>\n            </thead>\n          </table>\n          </div>\n        </td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <td>\n          <div class=\"scroller\">\n            <div class=\"time grid\">\n              <table class=\"layout fixed\">\n                <tbody>\n"
    + ((stack1 = helpers.each.call(depth0,(depth0 != null ? depth0.hours : depth0),{"name":"each","hash":{},"fn":this.program(1, data, 0, blockParams, depths),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "                </tbody>\n              </table>\n            </div>\n            <div class=\"appointment layout\">\n              <table class=\"layout fixed\">\n                <tbody>\n                  <tr class=\"appointments\">\n                    <td class=\"time gutter\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>";
},"useData":true,"useDepths":true});

this["Handlebars"]["App"]["calendar.week.popup"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui basic buttons two fluid\" style=\"margin-bottom: 1em;\">\n  <ui name=\"monthButton\"></ui>\n  <ui name=\"yearButton\"></ui>\n</div>\n<div>\n  <ui name=\"yearGrid\"></ui>\n</div>\n<div>\n  <ui name=\"monthGrid\"></ui>\n</div>";
},"useData":true});

this["Handlebars"]["App"]["checkbox"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "radio";
},"3":function(depth0,helpers,partials,data) {
    return "checkbox";
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "id=\""
    + this.escapeExpression(((helper = (helper = helpers.checkboxId || (depth0 != null ? depth0.checkboxId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"checkboxId","hash":{},"data":data}) : helper)))
    + "\"";
},"7":function(depth0,helpers,partials,data) {
    return "checked=\"checked\" aria-checked=\"true\"";
},"9":function(depth0,helpers,partials,data) {
    return "aria-checked=\"false\"";
},"11":function(depth0,helpers,partials,data) {
    var stack1;

  return "<label "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.checkboxId : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n";
},"12":function(depth0,helpers,partials,data) {
    var helper;

  return "for=\""
    + this.escapeExpression(((helper = (helper = helpers.checkboxId || (depth0 != null ? depth0.checkboxId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"checkboxId","hash":{},"data":data}) : helper)))
    + "\"";
},"14":function(depth0,helpers,partials,data) {
    return "    <ui name=\"input\" />\n";
},"16":function(depth0,helpers,partials,data) {
    var helper;

  return "    "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n";
},"18":function(depth0,helpers,partials,data) {
    return "</label>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<input\n  type=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.radio : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n  role=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.radio : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n  "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.checkboxId : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  name=\""
    + this.escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\"\n  "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.value : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "")
    + "\n  tabindex=\"0\"\n>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useLabel : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.input : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.program(16, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useLabel : depth0),{"name":"if","hash":{},"fn":this.program(18, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["component.with.info"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "      <ui name=\"helpIcon\"/>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"content flex-row\">\n    "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.helpText : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

this["Handlebars"]["App"]["default.popup"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"header\">"
    + this.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"header","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"content\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.header : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["dimmer"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"content\">\n  <div class=\"center\"><ui name=\"content\"></ui></div>\n</div>\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <ui name=\"content\"></ui>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.centered : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["divider"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)));
},"useData":true});

this["Handlebars"]["App"]["dropdown"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <i class=\""
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon "
    + alias3(((helper = (helper = helpers.textColor || (depth0 != null ? depth0.textColor : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"textColor","hash":{},"data":data}) : helper)))
    + "\"></i>\n";
},"4":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"header\">"
    + this.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"header","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"6":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "");
},"7":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconOnly : depth0),{"name":"unless","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"8":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <div class=\"text "
    + alias3(((helper = (helper = helpers.textColor || (depth0 != null ? depth0.textColor : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"textColor","hash":{},"data":data}) : helper)))
    + "\">\n    "
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n  </div>\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconOnly : depth0),{"name":"unless","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    var helper;

  return "    <div class=\"default text\">\n      "
    + this.escapeExpression(((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"placeholder","hash":{},"data":data}) : helper)))
    + "\n    </div>\n";
},"13":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(14, data, 0),"data":data})) != null ? stack1 : "");
},"14":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconOnly : depth0),{"name":"unless","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"15":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"default text\">\n    "
    + this.escapeExpression(((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"placeholder","hash":{},"data":data}) : helper)))
    + "\n  </div>\n";
},"17":function(depth0,helpers,partials,data) {
    return "    <ui name=\"input\"></ui>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"ui clear button inline\">Clear</div>\n"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconRight : depth0),{"name":"unless","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.header : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconTop : depth0),{"name":"unless","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.iconRight : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.iconTop : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"menu\">\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.input : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});

this["Handlebars"]["App"]["dropdown.itemview"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.fluid : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " icon\"></i>\n";
},"2":function(depth0,helpers,partials,data) {
    return "right floated";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <img src=\""
    + alias3(((helper = (helper = helpers.imageUrl || (depth0 != null ? depth0.imageUrl : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"imageUrl","hash":{},"data":data}) : helper)))
    + "\" alt=\""
    + alias3(((helper = (helper = helpers.imageAlt || (depth0 != null ? depth0.imageAlt : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"imageAlt","hash":{},"data":data}) : helper)))
    + "\" style=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.imageWidth : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.imageHeight : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" >\n";
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "width: "
    + this.escapeExpression(((helper = (helper = helpers.imageWidth || (depth0 != null ? depth0.imageWidth : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"imageWidth","hash":{},"data":data}) : helper)))
    + ";";
},"7":function(depth0,helpers,partials,data) {
    var helper;

  return "height:"
    + this.escapeExpression(((helper = (helper = helpers.imageHeight || (depth0 != null ? depth0.imageHeight : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"imageHeight","hash":{},"data":data}) : helper)))
    + ";";
},"9":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"ui label circular empty "
    + this.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"color","hash":{},"data":data}) : helper)))
    + "\"></div>";
},"11":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <span class=\""
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.fluid : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " description\">"
    + this.escapeExpression(((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"description","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"13":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"menu "
    + this.escapeExpression(((helper = (helper = helpers.menuDirection || (depth0 != null ? depth0.menuDirection : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"menuDirection","hash":{},"data":data}) : helper)))
    + "\"></div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.imageUrl : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.color : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.description : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.hasChildren : depth0),{"name":"if","hash":{},"fn":this.program(13, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["error_helper"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "    <div class=\"sub header red\">"
    + this.escapeExpression(((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"subText","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<i class=\"ban icon\"></i>\n<div class=\"content\">\n  "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.subText : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

this["Handlebars"]["App"]["form.field"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <label"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.forElementId : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " class=\"flex-row\">\n      "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.helpText : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </label>\n";
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return " for=\""
    + this.escapeExpression(((helper = (helper = helpers.forElementId || (depth0 != null ? depth0.forElementId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"forElementId","hash":{},"data":data}) : helper)))
    + "\"";
},"4":function(depth0,helpers,partials,data) {
    return "          <ui name=\"helpIcon\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["header"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <i class=\"icon "
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\"></i>\n  <div class=\"content\">\n    "
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.subText : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "  </div>\n";
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return "      <div class=\"sub header\">"
    + this.escapeExpression(((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"subText","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.subText : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "    <div class=\"sub header\">"
    + this.escapeExpression(((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"subText","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["help.icon"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<i class=\"info circle icon small-icon\"></i>";
},"useData":true});

this["Handlebars"]["App"]["input.counter"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"input\" />\n<div class=\"ui vertical buttons\">\n  <ui name=\"increment\" />\n  <ui name=\"decrement\" />\n</div>";
},"useData":true});

this["Handlebars"]["App"]["input.currency"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"input\" />\n";
},"useData":true});

this["Handlebars"]["App"]["input.date"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <ui type=\"container\" name=\"inlineView\" className=\"calendar-inline\" visible=\"false\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ui type=\"input\" name=\"input\" />\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.inlineCalendar : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["input"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.labelRight : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <label class=\"ui label\" for=\""
    + alias3(((helper = (helper = helpers.inputId || (depth0 != null ? depth0.inputId : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"inputId","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"label","hash":{},"data":data}) : helper)))
    + "</label>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.buttonRight : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"5":function(depth0,helpers,partials,data) {
    return "    <ui name=\"button\" />\n";
},"7":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <textarea\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.inputId : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    name=\""
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\"\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.placeholder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    rows=\""
    + alias3(((helper = (helper = helpers.rowCount || (depth0 != null ? depth0.rowCount : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"rowCount","hash":{},"data":data}) : helper)))
    + "\"\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.readonly : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.maxLength : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.required : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  >"
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "</textarea>\n";
},"8":function(depth0,helpers,partials,data) {
    var helper;

  return "id=\""
    + this.escapeExpression(((helper = (helper = helpers.inputId || (depth0 != null ? depth0.inputId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"inputId","hash":{},"data":data}) : helper)))
    + "\"";
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "placeholder=\""
    + this.escapeExpression(((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"placeholder","hash":{},"data":data}) : helper)))
    + "\"";
},"12":function(depth0,helpers,partials,data) {
    return "readonly=\"true\"";
},"14":function(depth0,helpers,partials,data) {
    var helper;

  return "maxlength=\""
    + this.escapeExpression(((helper = (helper = helpers.maxLength || (depth0 != null ? depth0.maxLength : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"maxLength","hash":{},"data":data}) : helper)))
    + "\"";
},"16":function(depth0,helpers,partials,data) {
    return "required aria-required=\"true\"";
},"18":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <input\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.inputId : depth0),{"name":"if","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    type=\""
    + alias3(((helper = (helper = helpers.inputType || (depth0 != null ? depth0.inputType : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"inputType","hash":{},"data":data}) : helper)))
    + "\"\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.placeholder : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    value=\""
    + alias3(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\"\n    name=\""
    + alias3(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\"\n    "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.inputAutocomplete : depth0),{"name":"unless","hash":{},"fn":this.program(19, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.required : depth0),{"name":"if","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.readonly : depth0),{"name":"if","hash":{},"fn":this.program(12, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n    "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.maxLength : depth0),{"name":"if","hash":{},"fn":this.program(14, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  >\n";
},"19":function(depth0,helpers,partials,data) {
    return "autocomplete=\"off\"";
},"21":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"23":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.labelRight : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"25":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.buttonRight : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"27":function(depth0,helpers,partials,data) {
    return "  <ui name=\"resultsView\"/>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.label : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.button : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.multiLine : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.program(18, data, 0),"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(21, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.label : depth0),{"name":"if","hash":{},"fn":this.program(23, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.button : depth0),{"name":"if","hash":{},"fn":this.program(25, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.typeAheadFind : depth0),{"name":"if","hash":{},"fn":this.program(27, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["instant.notification"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"content\">\n  "
    + this.escapeExpression(((helper = (helper = helpers.details || (depth0 != null ? depth0.details : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"details","hash":{},"data":data}) : helper)))
    + "\n</div>\n\n<div class=\"actions\"></div>\n";
},"useData":true});

this["Handlebars"]["App"]["label"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"detail\">"
    + this.escapeExpression(((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"detail","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"5":function(depth0,helpers,partials,data) {
    return "  <i class=\"close icon\" tabindex=\"0\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<span class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</span>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.detail : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closeable : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["list.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <ui name=\"rightContainer\" />\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"5":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "  <img src=\""
    + alias3(((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"image","hash":{},"data":data}) : helper)))
    + "\" alt=\""
    + alias3(((helper = (helper = helpers.imageAlt || (depth0 != null ? depth0.imageAlt : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"imageAlt","hash":{},"data":data}) : helper)))
    + "\" class=\"ui image "
    + alias3(((helper = (helper = helpers.imageClass || (depth0 != null ? depth0.imageClass : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"imageClass","hash":{},"data":data}) : helper)))
    + "\">\n";
},"7":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"header\">"
    + this.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"header","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"9":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "    <a "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.linkHref : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " class=\"description\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</a>\n";
},"10":function(depth0,helpers,partials,data) {
    var helper;

  return "href=\""
    + this.escapeExpression(((helper = (helper = helpers.linkHref || (depth0 != null ? depth0.linkHref : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"linkHref","hash":{},"data":data}) : helper)))
    + "\"";
},"12":function(depth0,helpers,partials,data) {
    var helper;

  return "    <div class=\"description\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useRightContainer : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"content\">\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.header : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(9, data, 0),"inverse":this.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>";
},"useData":true});

this["Handlebars"]["App"]["list.navigation"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"table-container\"></div>";
},"useData":true});

this["Handlebars"]["App"]["loader"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)));
},"useData":true});

this["Handlebars"]["App"]["menu"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"ui page grid\">\n  <div class=\"column\">\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <div class=\"title\">\n    <ui name=\"title\"></ui>\n  </div>\n";
},"5":function(depth0,helpers,partials,data) {
    return "  </div>\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.page : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"right menu\"></div>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.title : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.page : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["menu.image.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "width=\""
    + this.escapeExpression(((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"width","hash":{},"data":data}) : helper)))
    + "\"";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "height=\""
    + this.escapeExpression(((helper = (helper = helpers.height || (depth0 != null ? depth0.height : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"height","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<img src=\""
    + alias3(((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"image","hash":{},"data":data}) : helper)))
    + "\" alt=\""
    + alias3(((helper = (helper = helpers.alt || (depth0 != null ? depth0.alt : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"alt","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.width : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.height : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">";
},"useData":true});

this["Handlebars"]["App"]["menu.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "  <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <ui name=\"label\" />\n";
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "  <span class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"7":function(depth0,helpers,partials,data) {
    return "  <ui name=\"subMenu\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.label : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.iconOnly : depth0),{"name":"unless","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.subMenu : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["message"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<i class=\"close icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"header\">"
    + this.escapeExpression(((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"header","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"5":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <p class=\"text\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.dismissable : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.header : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<ul class=\"list\"></ul>";
},"useData":true});

this["Handlebars"]["App"]["modal.actions.fluid"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "inverted";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"ui "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.buttons : depth0)) != null ? stack1.length : stack1), depth0))
    + " fluid "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.basic : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " buttons\"></div>";
},"useData":true});

this["Handlebars"]["App"]["modal.content"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"image\">\n    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n  </div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"description\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>";
},"useData":true});

this["Handlebars"]["App"]["modal"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closeIcon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return "    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.closeIcon || (depth0 != null ? depth0.closeIcon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"closeIcon","hash":{},"data":data}) : helper)))
    + " icon\" tabindex=\"0\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closable : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<ui name=\"header\"></ui>\n<ui name=\"content\"></ui>\n<ui name=\"actions\"></ui>";
},"useData":true});

this["Handlebars"]["App"]["modal.header"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)));
},"useData":true});

this["Handlebars"]["App"]["modal2"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closeIcon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return "    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.closeIcon || (depth0 != null ? depth0.closeIcon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"closeIcon","hash":{},"data":data}) : helper)))
    + " icon\" tabindex=\"0\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closable : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<ui name=\"headerView\"></ui>\n<ui name=\"contentView\"></ui>\n<ui name=\"actionsView\"></ui>";
},"useData":true});

this["Handlebars"]["App"]["popup"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"content\"></ui>";
},"useData":true});

this["Handlebars"]["App"]["progress"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"label\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"bar\" style=\"transition: "
    + alias3(((helper = (helper = helpers.transition || (depth0 != null ? depth0.transition : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"transition","hash":{},"data":data}) : helper)))
    + "; -webkit-transition: "
    + alias3(((helper = (helper = helpers.transition || (depth0 != null ? depth0.transition : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"transition","hash":{},"data":data}) : helper)))
    + "; width: "
    + alias3(((helper = (helper = helpers.percent || (depth0 != null ? depth0.percent : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"percent","hash":{},"data":data}) : helper)))
    + "%;\">\n  <div class=\"progress\"></div>\n</div>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["result"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "aria-selected=\"true\"";
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return "  <div class=\"description\">"
    + this.escapeExpression(((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"description","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"content\" role=\"option\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n  <div class=\"title\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.description : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});

this["Handlebars"]["App"]["step"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "<i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "	<span role=\"option\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n		"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n	</span>\n";
},"4":function(depth0,helpers,partials,data) {
    return "aria-current=\"step\"";
},"6":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "	<div role=\"option\" class=\"content\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">\n		<div class=\"title\">"
    + this.escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"title","hash":{},"data":data}) : helper)))
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.description : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "	</div>\n";
},"7":function(depth0,helpers,partials,data) {
    var helper;

  return "		<div class=\"description\">"
    + this.escapeExpression(((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"description","hash":{},"data":data}) : helper)))
    + "</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.text : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["table.cell"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useInlineLink : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <a href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\" target=\""
    + alias3(((helper = (helper = helpers.linkTarget || (depth0 != null ? depth0.linkTarget : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"linkTarget","hash":{},"data":data}) : helper)))
    + "\">\n";
},"4":function(depth0,helpers,partials,data) {
    return "    <span>\n";
},"6":function(depth0,helpers,partials,data) {
    return "  <ui name=\"columnChildView\" />\n";
},"8":function(depth0,helpers,partials,data) {
    var helper;

  return "  "
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n";
},"10":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useInlineLink : depth0),{"name":"if","hash":{},"fn":this.program(11, data, 0),"inverse":this.program(13, data, 0),"data":data})) != null ? stack1 : "");
},"11":function(depth0,helpers,partials,data) {
    return "    </a>\n";
},"13":function(depth0,helpers,partials,data) {
    return "    </span>\n";
},"15":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.useInlineLink : depth0),{"name":"unless","hash":{},"fn":this.program(16, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"16":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "    <a\n      href=\""
    + alias3(((helper = (helper = helpers.link || (depth0 != null ? depth0.link : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"link","hash":{},"data":data}) : helper)))
    + "\"\n      "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.linkAriaLabel : depth0),{"name":"if","hash":{},"fn":this.program(17, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n      role=\"button\"\n      target=\""
    + alias3(((helper = (helper = helpers.linkTarget || (depth0 != null ? depth0.linkTarget : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"linkTarget","hash":{},"data":data}) : helper)))
    + "\"\n      tabindex=\""
    + alias3(((helper = (helper = helpers.linkTabIndex || (depth0 != null ? depth0.linkTabIndex : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"linkTabIndex","hash":{},"data":data}) : helper)))
    + "\"\n      style=\"position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px\"\n      ></a>\n";
},"17":function(depth0,helpers,partials,data) {
    var helper;

  return "aria-label=\""
    + this.escapeExpression(((helper = (helper = helpers.linkAriaLabel || (depth0 != null ? depth0.linkAriaLabel : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"linkAriaLabel","hash":{},"data":data}) : helper)))
    + "\"";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.hasChildView : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(10, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(15, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["table.empty"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<td colspan=\""
    + alias3(((helper = (helper = helpers.columns || (depth0 != null ? depth0.columns : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"columns","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</td>";
},"useData":true});

this["Handlebars"]["App"]["table"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <caption "
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.showCaption : depth0),{"name":"unless","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + this.escapeExpression(((helper = (helper = helpers.caption || (depth0 != null ? depth0.caption : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"caption","hash":{},"data":data}) : helper)))
    + "</caption>\n";
},"2":function(depth0,helpers,partials,data) {
    return "class=\"accessiblity-text\"";
},"4":function(depth0,helpers,partials,data) {
    var stack1;

  return "<tfoot>\n  <tr>\n    <td colspan=\""
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.columns : depth0)) != null ? stack1.length : stack1), depth0))
    + "\" class=\"item count\"></td>\n  </tr>\n</tfoot>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.caption : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<thead>\n  <tr></tr>\n  <tr class=\"responsive sort\"><th><ui name=\"dropdown\" /></th></tr>\n</thead>\n<tbody></tbody>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.itemCount : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["table.header"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "  <span class=\"accessiblity-text\">"
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.text : stack1), depth0))
    + "</span>\n  <ui name=\"columnHeaderChildView\" />\n";
},"3":function(depth0,helpers,partials,data) {
    var stack1;

  return "  "
    + this.escapeExpression(this.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.text : stack1), depth0))
    + "\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.hasHeaderChildView : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["table.row.header"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<td colspan=\""
    + alias3(((helper = (helper = helpers.columns || (depth0 != null ? depth0.columns : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"columns","hash":{},"data":data}) : helper)))
    + "\">"
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</td>";
},"useData":true});

this["Handlebars"]["App"]["text"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "");
},"3":function(depth0,helpers,partials,data) {
    var helper;

  return this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)));
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.renderAsHtml : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["token"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "<i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<span>"
    + alias3(((helper = (helper = helpers.separator || (depth0 != null ? depth0.separator : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"separator","hash":{},"data":data}) : helper)))
    + " </span><div class=\"detail\">"
    + alias3(((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"detail","hash":{},"data":data}) : helper)))
    + "</div>";
},"5":function(depth0,helpers,partials,data) {
    return " <i class=\"close icon\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.single : depth0),{"name":"unless","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closeable : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["token.input"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "<i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>";
},"3":function(depth0,helpers,partials,data) {
    return "<i class=\"token clear remove circle icon\"></i>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"prompt\">\n  "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n  <div class=\"placeholder\">"
    + this.escapeExpression(((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"placeholder","hash":{},"data":data}) : helper)))
    + "</div>\n  <div class=\"token box\"></div>\n  <div class=\"token input\" contentEditable=\"true\" tabindex=\"0\"></div>\n  "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.allowClearAll : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n<ui name=\"resultsView\"/>\n";
},"useData":true});

this["Handlebars"]["App"]["tree.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"title\" tabindex=\"0\">\n  <i class=\"dropdown icon\" tabindex=\"0\"></i>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.link : depth0),{"name":"if","hash":{},"fn":this.program(4, data, 0),"inverse":this.program(9, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n<div class=\"content\"></div>\n";
},"2":function(depth0,helpers,partials,data) {
    var helper;

  return "    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"4":function(depth0,helpers,partials,data) {
    var stack1, helper;

  return "    <a class=\"text\" "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.href : depth0),{"name":"if","hash":{},"fn":this.program(5, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.target : depth0),{"name":"if","hash":{},"fn":this.program(7, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + " tabindex=\"-1\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</a>\n";
},"5":function(depth0,helpers,partials,data) {
    var helper;

  return "href=\""
    + this.escapeExpression(((helper = (helper = helpers.href || (depth0 != null ? depth0.href : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"href","hash":{},"data":data}) : helper)))
    + "\"";
},"7":function(depth0,helpers,partials,data) {
    var helper;

  return "target=\""
    + this.escapeExpression(((helper = (helper = helpers.target || (depth0 != null ? depth0.target : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"target","hash":{},"data":data}) : helper)))
    + "\"";
},"9":function(depth0,helpers,partials,data) {
    var helper;

  return "    <span class=\"text\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.isAllowed : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["tutorial"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"spotlight\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1;\">\n  <div class=\"full\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; background: rgba(0, 0, 0, "
    + alias3(((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"opacity","hash":{},"data":data}) : helper)))
    + ");\"></div>\n  <div class=\"left\" style=\"position: absolute; top: 0px; left: 0px; bottom: 0px; background: rgba(0, 0, 0, "
    + alias3(((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"opacity","hash":{},"data":data}) : helper)))
    + ");\"></div>\n  <div class=\"right\" style=\"position: absolute; top: 0px; bottom: 0px; right: 0px; background: rgba(0, 0, 0, "
    + alias3(((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"opacity","hash":{},"data":data}) : helper)))
    + ");\"></div>\n  <div class=\"top\" style=\"position: absolute; top: 0px; left: 0px; background: rgba(0, 0, 0, "
    + alias3(((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"opacity","hash":{},"data":data}) : helper)))
    + ");\"></div>\n  <div class=\"bottom\" style=\"position: absolute; bottom: 0px; left: 0px; background: rgba(0, 0, 0, "
    + alias3(((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"opacity","hash":{},"data":data}) : helper)))
    + ");\"></div>\n</div>\n<div class=\"arrows\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1;\">\n  <canvas style=\"position: absolute; top: 0px; left: 0px;\"></canvas>\n</div>\n<div class=\"content\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 2;\"></div>";
},"useData":true});

this["Handlebars"]["App"]["visual.search"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<div class=\"prompt\">\n  <i class=\""
    + alias3(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n  <div class=\"placeholder\">"
    + alias3(((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"placeholder","hash":{},"data":data}) : helper)))
    + "</div>\n  <div class=\"token box\"></div>\n  <div class=\"token input\" contentEditable=\"true\"></div>\n  <i class=\"token clear remove circle icon\"></i>\n</div>\n<ui name=\"tokenResultsView\" />\n<ui name=\"fieldResultsView\" />";
},"useData":true});

this["Handlebars"]["App"]["visual.search.result.footer"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return "<i class=\"count\">"
    + alias3(((helper = (helper = helpers.count || (depth0 != null ? depth0.count : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"count","hash":{},"data":data}) : helper)))
    + "</i>\n<span class=\"description\">"
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</span>";
},"useData":true});

this["Handlebars"]["App"]["visual.search.result"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"content\">\n  <div class=\"title\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n</div>";
},"useData":true});

this["Handlebars"]["App"]["visual.search.token"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "    <i class=\""
    + this.escapeExpression(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"icon","hash":{},"data":data}) : helper)))
    + " icon\"></i>\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <i class=\"close icon\"></i>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, alias1=helpers.helperMissing, alias2="function", alias3=this.escapeExpression;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.icon : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + alias3(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "\n<div class=\"detail\">"
    + alias3(((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : alias1),(typeof helper === alias2 ? helper.call(depth0,{"name":"detail","hash":{},"data":data}) : helper)))
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.closeable : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["base.content"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <div class=\"answer-wrapper\" style=\"background: transparent;\">\n    <ui name=\"previewAnswerView\" />\n  </div>\n  <ui name=\"errorMessageView\" />\n";
},"3":function(depth0,helpers,partials,data) {
    return "  <ui name=\"designDividerView\" />\n  <ui name=\"designTabView\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ui name=\"previewGeneralView\" />\n\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.hasAnswer : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.designable : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["base.finder.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui right aligned basic fitted segment\">\n  <ui type=\"button\" name=\"addButtonView\" />\n</div>\n<ui type=\"table\" name=\"displayAnswersView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["base.finder.empty.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<td>\n  <div class=\"ui basic fitted center aligned segment\">\n    <ui type=\"text\" name=\"emptyTextView\" />\n    <ui type=\"divider\" name=\"addButtonViewDivider\" />\n    <ui type=\"button\" name=\"addButtonView\" />\n  </div>\n</td>";
},"useData":true});

this["Handlebars"]["App"]["base.finder"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui blue top attached segment\">\n <ui type=\"text\" name=\"selectedTextView\" />\n</div>\n<div class=\"ui bottom attached fitted segment\">\n <ui type=\"table\" name=\"selectedTableView\" basic=\"true\" borderless=\"true\" />\n</div>\n\n<div class=\"ui hidden divider\"></div>\n\n<div class=\"ui blue top attached segment\">\n  <ui type=\"token-input\" name=\"visualSearchView\" singlevalue=\"false\" freetext=\"false\"/>\n</div>\n<div class=\"ui bottom attached fitted segment\">\n  <ui type=\"table\" name=\"searchTableView\" basic=\"true\" borderless=\"true\" />\n</div>";
},"useData":true});

this["Handlebars"]["App"]["base.form.object"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "selectable";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"ui segments\">\n  <div class=\"ui segment top toolbar "
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.designable : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <ui name=\"topView\" />\n  </div>\n\n  <div class=\"ui segment\">\n    <ui name=\"contentView\" />\n  </div>\n\n  <ui name=\"bottomView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["checkbox.content"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"field\">\n  <ui type=\"button\" name=\"addButton\" icon=\"plus\" basic=\"true\" />\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"grouped fields\"></div>\n\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.showAdd : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Handlebars"]["App"]["checkbox.object.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<h5 class=\"ui header\">Add Check Box Options</h5>\n<ui name=\"collectionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["checkbox.object.preview"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"groupView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["date.time.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui form date-time-selector\">\n  <div class=\"fields three\">\n    <div class=\"five wide field\"><ui name=\"dateView\" /></div>\n    <div class=\"five wide field\"><ui name=\"timeView\" /></div>\n    <div class=\"six wide field\"><ui name=\"timezoneView\" /></div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["dropdown.object.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<h5 class=\"ui header\">Add Dropdown Options</h5>\n<ui name=\"collectionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["dropdown.object.preview"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"groupView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["form.object.collection.empty"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"mainText\">No Objects Added</div>\n<span class=\"muted\">Add an object from the right sidebar by clicking or drag-and-drop an object to start creating your form!</span>\n<div class=\"ui loading button section-loading\"><span class=\"loading-text\">Loading</span></div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.object.content.preview.general"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"labelView\" /> <ui name=\"titleView\" /> <ui name=\"requiredQuestionView\" />\n<div><ui type=\"text\" name=\"descriptionView\" /></div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.object.edit"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<div class=\"content\">\n  <ui name=\"content\" />\n</div>\n";
},"3":function(depth0,helpers,partials,data) {
    return "<div class=\"ui buttons left floated\">\n  <ui type=\"button\" name=\"doneBtn\" text=\"Done\" stoppropagation=\"true\" />\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ui name=\"top\" />\n\n<div class=\"header\">\n  <ui type=\"form\" name=\"headerForm\" />\n</div>\n\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.content : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.active : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n<ui name=\"bottom\" />";
},"useData":true});

this["Handlebars"]["App"]["form.object.top"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui stackable two column grid\">\n  <div class=\"column\">\n    <ui name=\"indicatorView\" />\n  </div>\n  <div class=\"column right aligned\">\n    <div class=\"ui basic fitted segment\">\n      <ui type=\"container\" name=\"actionsView\" />\n    </div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.object.type.menu.composite"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"headerView\" />\n<div class=\"form-object-types ui list\"></div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.object.type.menu.item"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"content\">\n  <ui name=\"formObjectButtonView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["data.label.selector"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var helper;

  return "<ui name=\"toggleButtonView\" />\n<div class=\"ui labelText\">"
    + this.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n<div class=\"data-label-menu\">\n  <ui name=\"userDefinedLabelInputView\" />\n  <div class=\"ui header\">\n     Or select a label below\n  </div>\n  <ui name=\"tagMenuView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.basic.answer"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui stackable grid form-preview\">\n  <div class=\"row\">\n    <div class=\"four wide tablet three wide computer two wide widescreen column\">\n      <ui name=\"sectionCompositeView\" />\n    </div>\n\n    <div class=\"twelve wide tablet thirteen wide computer fourteen wide widescreen column\">\n      <div class=\"ui fitted basic segment\">\n        <ui name=\"sectionHeaderCollectionView\" />\n      </div>\n      <div class=\"ui fitted basic segment\">\n        <ui name=\"formObjectCollectionBySectionCollectionView\" />\n      </div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["form.basic.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui stackable grid form-design\">\n  <div class=\"row\">\n    <div class=\"four wide tablet three wide computer three wide large screen three wide widescreen column\">\n      <ui name=\"sectionCompositeView\" />\n    </div>\n\n    <div class=\"eight wide tablet ten wide computer ten wide large screen ten wide widescreen column\">\n      <div class=\"ui fitted basic segment\">\n        <ui name=\"sectionHeaderCollectionView\" />\n      </div>\n      <div class=\"ui fitted basic segment\">\n        <ui name=\"formObjectCollectionBySectionCollectionView\" />\n      </div>\n    </div>\n\n    <div class=\"four wide tablet three wide computer three wide large screen three wide widescreen column\">\n      <ui name=\"formObjectMenuCompositeView\" />\n    </div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["group.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"formObjectList\" />";
},"useData":true});

this["Handlebars"]["App"]["group.form.object.bottom"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "<ui type=\"button\" name=\"dragHandle\" classname=\"ui drag-handle button\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.useDragHandle : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<ui name=\"foAddBtn\" />";
},"useData":true});

this["Handlebars"]["App"]["information.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "";
},"useData":true});

this["Handlebars"]["App"]["radio.object.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<h5 class=\"ui header\">Add Radio Options</h5>\n<ui name=\"collectionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["radio.object.preview"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"groupView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["rule.item"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"ruleDividerView\" />\n<div class=\"ui fitted basic segment\">\n  <ui name=\"ruleHeaderView\" />\n  <ui name=\"removeRuleButtonView\" />\n  <ui name=\"conditionCollectionView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["rule.item.header"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui stackable two column grid\">\n  <div class=\"ui column\">\n    <ui name=\"headerTextView\" /> <ui name=\"headerIndexView\" />\n  </div>\n  <div class=\"ui column\">\n    <div class=\"ui right floated basic fitted segment\">\n      <ui name=\"removeButtonView\" />\n    </div>\n  </div>\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["rules.composite"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"descriptionTextView\" />\n<ui name=\"descriptionDividerView\" />\n\n<div class=\"rulesContainer\"></div>\n\n<ui name=\"addRuleButtonDividerView\" />\n<ui name=\"addRuleButtonView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["section.composite"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"ui top attached segment grid\">\n  <div class=\"two column white row\">\n    <div class=\"left floated column\"><ui name=\"sectionTitleView\" /></div>\n    <div class=\"right floated column\"><ui name=\"addSectionButton\" /></div>\n  </div>\n</div>\n<div class=\"sections ui bottom attached fitted segment\"></div>\n";
},"useData":true});

this["Handlebars"]["App"]["section.header.answer"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<div class=\"column\">\n  <ui name=\"headerTextView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["section.item"] = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "  <ui type=\"dropdown\" name=\"actionsView\" />\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"controls\">\n"
    + ((stack1 = helpers["if"].call(depth0,(depth0 != null ? depth0.enableActions : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n<div class=\"info\">\n  <strong><ui type=\"text\" name=\"labelView\" /></strong>\n  <ui type=\"text\" name=\"textView\" />\n  <ui name=\"failedValidationsCountView\" />\n</div>\n";
},"useData":true});

this["Handlebars"]["App"]["table.object.design"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<h5 class=\"ui header\">Manage Columns</h5>\n<ui name=\"collectionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["table.object.header.cell"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"textView\" /> <ui name=\"requiredQuestionView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["table.object.preview"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"tableView\" />\n<ui name=\"addRowButtonView\" />\n";
},"useData":true});

this["Handlebars"]["App"]["table.object.settings.sidebar.content"] = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ui name=\"headerView\" />\n<ui name=\"headerDividerView\" />\n<div class=\"ui basic fitted segment\">\n  <div class=\"ui right floated basic fitted segment\">Preview</div>\n</div>\n<div class=\"ui basic fitted segment\">\n  <h5><ui name=\"previewTitleView\" /> <ui name=\"previewTitleRequiredQuestionView\" /></h5>\n</div>\n<div class=\"ui basic segment\">\n  <ui name=\"previewView\"/>\n</div>\n<ui name=\"designDividerView\" />\n<div class=\"ui basic fitted segment\">\n  <div class=\"ui right floated basic fitted segment\">Design</div>\n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"designView\" />\n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"requiredQuestionView\" />\n</div>\n<div class=\"ui basic fitted segment\">\n  <ui name=\"doneButtonView\" />\n</div>\n";
},"useData":true});

return this["Handlebars"];

});
